import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AsyncButton, Avatar, SaveStates } from '@infl-ts/ui-advocate-components';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, TextField } from '@mui/material';
import * as E from 'fp-ts/Either';
import * as Str from 'fp-ts/string';
import { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as alerts from '../alerts';
import { useCommentOnPublic } from '../mutations';
import { useComments } from '../queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Saving = SaveStates.Saving,
    Default = SaveStates.Default,
    Error = SaveStates.Error;

var ReplyInput = function ReplyInput(_ref) {
  var replyInputRef = _ref.replyInputRef,
      profile = _ref.profile,
      publicResponseId = _ref.publicResponseId,
      totalFetched = _ref.totalFetched,
      onReplySuccess = _ref.onReplySuccess;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useState = useState(''),
      reply = _useState[0],
      setReply = _useState[1];

  var _useState2 = useState(null),
      inputError = _useState2[0],
      setInputError = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useCommentOnPublic = useCommentOnPublic({
    awaitRefetchQueries: true,
    onCompleted: E.match(function () {
      return showAlert(alerts.unableToReply());
    }, function (_ref2) {
      var commentOnPublicResponse = _ref2.commentOnPublicResponse;

      if (commentOnPublicResponse.__typename === 'CommentOnPublicResponseErrors') {
        showAlert(alerts.unableToReply(commentOnPublicResponse.errors[0].message));
      } else {
        if (replyInputRef.current) {
          replyInputRef.current.value = '';
          replyInputRef.current.focus();
        }

        onReplySuccess(commentOnPublicResponse.result.id);
        setReply('');
      }
    }),
    refetchQueries: [{
      query: useComments.document,
      variables: {
        responseId: publicResponseId,
        commentsCursor: '0',
        first: totalFetched + 1
      }
    }]
  }),
      _useCommentOnPublic2 = _slicedToArray(_useCommentOnPublic, 2),
      commentOnPublic = _useCommentOnPublic2[0],
      mutationStatus = _useCommentOnPublic2[1];

  var sendComment = useCallback(function () {
    return Str.isEmpty(reply.trim()) ? setInputError(t('Reply cannot be empty')) : commentOnPublic({
      variables: {
        input: {
          id: publicResponseId,
          body: reply
        }
      }
    });
  }, [commentOnPublic, publicResponseId, reply]);
  var replyStatus = useMutationMapper(mutationStatus, function (_ref3) {
    var response = _ref3.commentOnPublicResponse;
    return response.__typename === 'CommentOnPublicResponseErrors' ? E.left(response) : E.right(response);
  }, [Saving, Default, Error, Default]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      ml: {
        xs: 5,
        md: 10
      },
      mr: 3,
      mt: {
        xs: 0,
        md: 2
      },
      mb: 2,
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      columnGap: 1,
      alignItems: {
        xs: 'end',
        md: 'start'
      }
    },
    "data-element": "Box",
    "data-component": "ReplyInput",
    "data-source-file": "reply-input.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        width: 1,
        mr: {
          xs: 0,
          md: 1
        }
      },
      "data-element": "Box",
      "data-component": "ReplyInput",
      "data-source-file": "reply-input.tsx",
      children: [/*#__PURE__*/_jsx(Avatar, {
        member: profile,
        disabledPopover: true,
        "data-element": "Avatar",
        "data-component": "ReplyInput",
        "data-source-file": "reply-input.tsx"
      }), /*#__PURE__*/_jsx(TextField, {
        sx: {
          flexGrow: 3,
          ml: 1
        },
        onChange: function onChange(event) {
          setInputError(null);
          setReply(event.target.value);
        },
        onKeyUp: function onKeyUp(event) {
          return event.key === 'Enter' && sendComment();
        },
        inputRef: replyInputRef,
        size: "small",
        label: t('Leave a reply'),
        disabled: replyStatus === 'saving',
        error: !!inputError,
        helperText: inputError !== null && inputError !== void 0 ? inputError : undefined,
        "data-element": "TextField",
        "data-source-file": "reply-input.tsx"
      })]
    }), /*#__PURE__*/_jsx(AsyncButton, {
      sx: {
        mt: {
          xs: 1,
          md: 0
        },
        width: 'fit-content'
      },
      onClick: sendComment,
      status: replyStatus,
      text: ['Replying...', 'Reply', 'Reply', 'Reply'],
      "data-element": "AsyncButton",
      "data-source-file": "reply-input.tsx"
    })]
  });
};

export default ReplyInput;